import { Dispatch, SetStateAction, useEffect, useRef } from "react";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { Input, Select } from "semantic-ui-react";
import { TranslateCountryProps } from "../../../i18n/TranslateProps";
import { ICertificate } from "../../../models/certificate";
import { IIDDataSet } from "../../../models/crewMember";
import { AppState } from "../../../store/configureStore";

type Props = {
    certificate: ICertificate;
    setCertificate: Dispatch<SetStateAction<ICertificate>>;
    idDataSet: IIDDataSet;
    isUpdate?: boolean;
    readonly?: boolean;
};

export const DeliveryInfoForm = ({
    certificate,
    setCertificate,
    idDataSet,
    isUpdate = false,
    readonly = false,
}: Props) => {
    const { countries } = useSelector((state: AppState) => state.nationalities);
    const intl = useIntl();
    const refIdDataSet = useRef(idDataSet);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCertificate(c => ({ ...c, [e.target.name]: e.target.value }));
    };

    useEffect(() => {
        !isUpdate &&
            setCertificate(c => ({
                ...c,
                nameLineOne: refIdDataSet.current.firstName,
                nameLineTwo: refIdDataSet.current.lastName,
                city: refIdDataSet.current.city,
                street: refIdDataSet.current.street,
                zipCode: refIdDataSet.current.zipCode,
                country: refIdDataSet.current.country,
            }));
    }, [setCertificate, isUpdate]);

    return (
        <div className="certificate-row six">
            <section className="input-container">
                <label>
                    {intl.formatMessage({ id: "nameLine1" })}
                    <span className="input-required">*</span>
                </label>
                <Input
                    name="nameLineOne"
                    value={certificate.nameLineOne ?? ""}
                    disabled={readonly}
                    onChange={handleInputChange}
                />
            </section>
            <section className="input-container">
                <label>
                    {intl.formatMessage({ id: "nameLine2" })}
                    <span className="input-required">*</span>
                </label>
                <Input
                    name="nameLineTwo"
                    value={certificate.nameLineTwo ?? ""}
                    disabled={readonly}
                    onChange={handleInputChange}
                />
            </section>
            <section className="input-container">
                <label>
                    {intl.formatMessage({ id: "zipCode" })}
                    <span className="input-required">*</span>
                </label>
                <Input
                    name="zipCode"
                    value={certificate.zipCode ?? ""}
                    disabled={readonly}
                    onChange={handleInputChange}
                />
            </section>
            <section className="input-container">
                <label>
                    {intl.formatMessage({ id: "city" })}
                    <span className="input-required">*</span>
                </label>
                <Input
                    name="city"
                    value={certificate.city ?? ""}
                    disabled={readonly}
                    onChange={handleInputChange}
                />
            </section>
            <section className="input-container">
                <label>
                    {intl.formatMessage({ id: "street" })}
                    <span className="input-required">*</span>
                </label>
                <Input
                    name="street"
                    value={certificate.street ?? ""}
                    disabled={readonly}
                    onChange={handleInputChange}
                    maxLength={40}
                />
            </section>
            <section className="input-container">
                <label>
                    {intl.formatMessage({ id: "country" })}
                    <span className="input-required">*</span>
                </label>
                <Select
                    selectOnBlur={false}
                    search
                    options={TranslateCountryProps(countries, intl.locale)}
                    value={certificate.country}
                    disabled={readonly}
                    onChange={(e, data: any) =>
                        setCertificate({ ...certificate, country: +data.value })
                    }
                />
            </section>
        </div>
    );
};
